import { DeckFileFormat } from "@apiserver-rest/ponder-data-client-base"

export type DeckFormatInfo = {
    format: DeckFileFormat,
    displayName: string,
    sample: string
};

export const DeckFormatInfos = new Map<DeckFileFormat, DeckFormatInfo>([
    [DeckFileFormat.Wizards, {
        format: DeckFileFormat.Wizards,
        displayName: "Wizards",
        sample: "1 Disa the Restless\n1 Coram, the Undertaker\n1 Find//Finality"
    }],
    [DeckFileFormat.Moxfield, {
        format: DeckFileFormat.Moxfield,
        displayName: "Moxfield",
        sample: "1 Disa the Restless (M3C) 1 *F*\n1 Accursed Marauder (MH3) 80\n1 Altar of the Goyf (M3C) 282\n1 Find // Finality (M3C) 261"
    }],
    [DeckFileFormat.MtgWtf, {
        format: DeckFileFormat.MtgWtf,
        displayName: "mtg.wtf",
        sample: "// NAME: Chaos Incarnate - Starter Commander Decks Commander Deck\n// URL: http://mtg.wtf/deck/scd/chaos-incarnate\n// DATE: 2022-12-02\nCOMMANDER: 1 Kardur, Doomscourge [SCD:5] [foil]\n1 Archfiend of Depravity [SCD:67]\n1 Bloodgift Demon [SCD:69]"
    }]
]);